<template>
  <header>
    <v-toolbar color="green" dark>
      <v-toolbar-title style="width: 300px;" class="ml-5 pl-3">
        <a :href="`${webUrl}`" target="_blank">
          <img src="@/assets/logo.png" style="width: 100px; height: 70px;" alt>
        </a>  
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
  </header>
</template>


<script>
import { webUrl } from '@/common/index'
import { mapGetters } from 'vuex';
export default {
  name: "HeaderComponent",
  computed: {
	...mapGetters(['webUrl'])
  }
};
</script>

<style scoped>

</style>